/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { DocumentStatus } from './DocumentStatus';
import {
    DocumentStatusFromJSON,
    DocumentStatusFromJSONTyped,
    DocumentStatusToJSON,
    DocumentStatusToJSONTyped,
} from './DocumentStatus';
import type { StaffDocumentFile } from './StaffDocumentFile';
import {
    StaffDocumentFileFromJSON,
    StaffDocumentFileFromJSONTyped,
    StaffDocumentFileToJSON,
    StaffDocumentFileToJSONTyped,
} from './StaffDocumentFile';
import type { StaffUserRef } from './StaffUserRef';
import {
    StaffUserRefFromJSON,
    StaffUserRefFromJSONTyped,
    StaffUserRefToJSON,
    StaffUserRefToJSONTyped,
} from './StaffUserRef';
import type { DocumentReceivedVia } from './DocumentReceivedVia';
import {
    DocumentReceivedViaFromJSON,
    DocumentReceivedViaFromJSONTyped,
    DocumentReceivedViaToJSON,
    DocumentReceivedViaToJSONTyped,
} from './DocumentReceivedVia';
import type { DocumentUploaderType } from './DocumentUploaderType';
import {
    DocumentUploaderTypeFromJSON,
    DocumentUploaderTypeFromJSONTyped,
    DocumentUploaderTypeToJSON,
    DocumentUploaderTypeToJSONTyped,
} from './DocumentUploaderType';

/**
 * 
 * @export
 * @interface StaffDocument
 */
export interface StaffDocument {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    display_name: string;
    /**
     * 
     */
    status: DocumentStatus;
    /**
     * 
     */
    source: DocumentUploaderType;
    /**
     * 
     */
    received_via: DocumentReceivedVia;
    /**
     * 
     */
    request_item_ids: Array<string>;
    /**
     * 
     */
    uploaded_by_user: StaffUserRef | null;
    /**
     * 
     */
    uploaded_by_participant_id: string | null;
    /**
     * 
     */
    attributed_participant_id: string | null;
    /**
     * 
     */
    received_at: Date | null;
    /**
     * Business office only
     */
    rejection_reason: string | null;
    /**
     * Shown to the uploader in the portal
     */
    participant_rejection_reason: string | null;
    /**
     * 
     */
    reviewed_at: Date | null;
    /**
     * 
     */
    reviewed_by_user: StaffUserRef | null;
    /**
     * 
     */
    batch_id: string;
    /**
     * 
     */
    files: Array<StaffDocumentFile>;
    /**
     * 
     */
    revision: number;
    /**
     * 
     */
    created_at: Date;
    /**
     * 
     */
    ready_at: Date | null;
}



/**
 * Check if a given object implements the StaffDocument interface.
 */
export function instanceOfStaffDocument(value: object): value is StaffDocument {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('display_name' in value) || value['display_name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('received_via' in value) || value['received_via'] === undefined) return false;
    if (!('request_item_ids' in value) || value['request_item_ids'] === undefined) return false;
    if (!('uploaded_by_user' in value) || value['uploaded_by_user'] === undefined) return false;
    if (!('uploaded_by_participant_id' in value) || value['uploaded_by_participant_id'] === undefined) return false;
    if (!('attributed_participant_id' in value) || value['attributed_participant_id'] === undefined) return false;
    if (!('received_at' in value) || value['received_at'] === undefined) return false;
    if (!('rejection_reason' in value) || value['rejection_reason'] === undefined) return false;
    if (!('participant_rejection_reason' in value) || value['participant_rejection_reason'] === undefined) return false;
    if (!('reviewed_at' in value) || value['reviewed_at'] === undefined) return false;
    if (!('reviewed_by_user' in value) || value['reviewed_by_user'] === undefined) return false;
    if (!('batch_id' in value) || value['batch_id'] === undefined) return false;
    if (!('files' in value) || value['files'] === undefined) return false;
    if (!('revision' in value) || value['revision'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('ready_at' in value) || value['ready_at'] === undefined) return false;
    return true;
}

export function StaffDocumentFromJSON(json: any): StaffDocument {
    return StaffDocumentFromJSONTyped(json, false);
}

export function StaffDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'display_name': json['display_name'],
        'status': DocumentStatusFromJSON(json['status']),
        'source': DocumentUploaderTypeFromJSON(json['source']),
        'received_via': DocumentReceivedViaFromJSON(json['received_via']),
        'request_item_ids': json['request_item_ids'],
        'uploaded_by_user': StaffUserRefFromJSON(json['uploaded_by_user']),
        'uploaded_by_participant_id': json['uploaded_by_participant_id'],
        'attributed_participant_id': json['attributed_participant_id'],
        'received_at': (json['received_at'] == null ? null : parseDateTime(json['received_at'])),
        'rejection_reason': json['rejection_reason'],
        'participant_rejection_reason': json['participant_rejection_reason'],
        'reviewed_at': (json['reviewed_at'] == null ? null : parseDateTime(json['reviewed_at'])),
        'reviewed_by_user': StaffUserRefFromJSON(json['reviewed_by_user']),
        'batch_id': json['batch_id'],
        'files': ((json['files'] as Array<any>).map(StaffDocumentFileFromJSON)),
        'revision': json['revision'],
        'created_at': (json['created_at'] == null ? json['created_at'] : parseDateTime(json['created_at'])),
        'ready_at': (json['ready_at'] == null ? null : parseDateTime(json['ready_at'])),
    };
}

export function StaffDocumentToJSON(json: any): StaffDocument {
    return StaffDocumentToJSONTyped(json, false);
}

export function StaffDocumentToJSONTyped(value?: StaffDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'display_name': value['display_name'],
        'status': DocumentStatusToJSON(value['status']),
        'source': DocumentUploaderTypeToJSON(value['source']),
        'received_via': DocumentReceivedViaToJSON(value['received_via']),
        'request_item_ids': value['request_item_ids'],
        'uploaded_by_user': StaffUserRefToJSON(value['uploaded_by_user']),
        'uploaded_by_participant_id': value['uploaded_by_participant_id'],
        'attributed_participant_id': value['attributed_participant_id'],
        'received_at': value['received_at'] == null ? value['received_at'] : serializeDateTime(value['received_at']),
        'rejection_reason': value['rejection_reason'],
        'participant_rejection_reason': value['participant_rejection_reason'],
        'reviewed_at': value['reviewed_at'] == null ? value['reviewed_at'] : serializeDateTime(value['reviewed_at']),
        'reviewed_by_user': StaffUserRefToJSON(value['reviewed_by_user']),
        'batch_id': value['batch_id'],
        'files': ((value['files'] as Array<any>).map(StaffDocumentFileToJSON)),
        'revision': value['revision'],
        'created_at': value['created_at'] == null ? value['created_at'] : serializeDateTime(value['created_at']),
        'ready_at': value['ready_at'] == null ? value['ready_at'] : serializeDateTime(value['ready_at']),
    };
}

